export default __webpack_public_path__ + "static/media/Financial Services.41d9bc32.svg";